import { render, staticRenderFns } from "./provider-list.vue?vue&type=template&id=3f198268"
import script from "./provider-list.vue?vue&type=script&lang=js"
export * from "./provider-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports